import React from 'react';
import PropTypes from 'prop-types';
import dataErrorIcon from 'assets/icons/data_error.svg';
import warningAltIcon from 'assets/icons/warning_alt.svg';

import './statusMessage.scss';

export const STATUS_MESSAGE_VARIANTS = {
  NO_DATA: 'no-data',
  TECHNICAL_ISSUE: 'technical-issue',
};

function StatusMessage({ variant, message, className }) {
  const isNoData = variant === STATUS_MESSAGE_VARIANTS.NO_DATA;

  return (
    <div
      className={`status-message ${className}`.trim()}
      data-testid="status-message"
    >
      <img
        className="status-message-icon"
        src={isNoData ? dataErrorIcon : warningAltIcon}
        alt=""
        aria-hidden="true"
        data-testid={isNoData ? 'status-icon-no-data' : 'status-icon-warning'}
      />
      <span className="status-message-divider" />
      <span className="status-message-text">{message}</span>
    </div>
  );
}

StatusMessage.propTypes = {
  variant: PropTypes.oneOf(Object.values(STATUS_MESSAGE_VARIANTS)).isRequired,
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
};

StatusMessage.defaultProps = {
  className: '',
};

export default StatusMessage;
